<template>
  <div class="toggle-pill">
    <div class="toggle-pill-container">
      <button
        v-for="(option, index) in options"
        :key="option.value"
        class="toggle-pill-btn"
        :class="{
          active: value === option.value,
          'first': index === 0,
          'last': index === options.length - 1
        }"
        @click="$emit('input', option.value)"
      >
        {{ option.text }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TogglePill',
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true,
      validator: (options) => options.every(option => 'text' in option && 'value' in option)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
